// Finar rev-B 11 — 409 KPI_METRIC_IN_USE `details.sets` okuyucusu (saf). Bozuk/eksik satır sessizce
// düşer; liste yoksa boş dizi (eski sunucu yanıtı → yalnız mesaj gösterilir).

import { KpiMetricInUseSetSchema, type KpiMetricInUseSet } from "@mahir/shared";

export function metricInUseSets(code: string | undefined, details: unknown): KpiMetricInUseSet[] {
  if (code !== "KPI_METRIC_IN_USE" || !details || typeof details !== "object") return [];
  const raw = (details as { sets?: unknown }).sets;
  if (!Array.isArray(raw)) return [];
  const out: KpiMetricInUseSet[] = [];
  for (const r of raw) {
    const p = KpiMetricInUseSetSchema.safeParse(r);
    if (p.success) out.push(p.data);
  }
  return out;
}
